var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.line)?_c('div',{staticClass:"nj-line"}):_vm._e(),_c('div',{staticClass:"nj-flx"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }